// eslint-disable-next-line
export default {
  id: 'carne_ninja',
  type: 'ninja',
  title: "Carne (Ninja's Version)",
  ingredients: [
    '500g carne',
    '1/2 cebola',
    '3 cenouras',
    '3 aipo',
    '1 alho',
    '1 colher de sopa de molho de tomate concentrado',
    '500ml de caldo de carne',
    '250ml de vinho tinto (opcional)',
  ],
  parts: [
    {
      title: 'Finalização',
      methodOfPreparation: [
        'Tempera a carne a gosto',
        'Sela a carne em uma frigideira',
        'Separa a carne',
        'Na mesma frigideira, refoga a cebola, alho ate dourado',
        'Adiciona todos os ingredientes (cenoura, aipo, molho de tomate concetrado, caldo de carne, vinho e a carne)',
        'Ferve por 1min, pra tirar o álcool',
        'Feche a panela de pressão',
        'Quick release, high pressure por 40min',
      ],
    },
  ],
};
